<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-warning-full-col`]" width="1em" height="1em" v-bind="$attrs"><path d="M56,0 C86.928,0 112,25.07208 112,56 C112,86.928 86.928,112 56,112 C25.07208,112 0,86.928 0,56 C0,25.07208 25.07208,0 56,0 Z M60.7391231,74 L52.2608685,74 C50.4599444,74 49,75.4599277 49,77.2608769 L49,77.2608769 L49,85.7391231 C49,87.5400723 50.4599444,89 52.2608685,89 L52.2608685,89 L60.7391231,89 C62.5400723,89 64,87.5400723 64,85.7391231 L64,85.7391231 L64,77.2608769 C64,75.4599277 62.5400723,74 60.7391231,74 L60.7391231,74 Z M60.7391231,25 L52.2608685,25 C50.4599444,25 49,26.466119 49,28.2746597 L49,28.2746597 L49,62.7253319 C49,64.5338136 50.4599444,66 52.2608685,66 L52.2608685,66 L60.7391231,66 C62.5400723,66 64,64.5338136 64,62.7253319 L64,62.7253319 L64,28.2746597 C64,26.466119 62.5400723,25 60.7391231,25 L60.7391231,25 Z" transform="translate(9 9)" :fill="useCurrentColor ? 'currentColor' : '#FF7D00'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmWarningFullCol',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
